import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ITenantSettings, IUpdateTenantSettingsAdminRequest, IUpdateTenantSettingsRequest } from '../models/tenant-setting';

@Injectable({
  providedIn: 'root'
})
export class TenantSettingService {

  constructor(private http: HttpClient) { }

  getTenantSettings(id: string){
    return this.http.get<ITenantSettings>(
      `${environment.baseUrl}/v1/TenantSettings/getTenantSettings/${id}`
    )
  }

  getCurrentTenantSettings(){
    return this.http.get<ITenantSettings>(
      `${environment.baseUrl}/v1/TenantSettings/getCurrentTenantSettings`
    )
  }

  updateTenantSettings(request: IUpdateTenantSettingsRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/TenantSettings/updateTenantSettings`,
      request
    )
  }

  updateTenantSettingsAdmin(request: IUpdateTenantSettingsAdminRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/TenantSettings/updateTenantSettingsAdmin/${request.id}`,
      request
    )
  }
}
